// @docs https://[domain]/api/v1/docs
export default {
  List: "pyr/features",
  Detail: "pyr/features",
  Update: "pyr/features",
  Create: "pyr/features",
  ListShort: "pyr/features/short",
};
